
export const SHIPPING_PRICE_EUR = 8;
export const SHIPPING_PRICE_CZK = 200;

export function toEUR( eur ) {
    /* if (eur < 8 && eur > 0) {
     return (eur).toFixed(3).replace(".", ",") + " €";
     } else {*/
    return ( eur ).toFixed( 2 ).replace( ".", "," ) + " €";
    //}
}

export function toCZK( czk ) {
    return ( czk ).toFixed( 2 ).replace( ".", "," ) + " Kč";
}

function product2Ga4Item( product, deltaQty ) {

    const ga4Item = {
        item_id: product.catalogNumber,
        item_name: product.productName,
        item_category: product.sectorName,
        item_category2: product.catalogName,
        price: product.priceCZKWithVat,
        quantity: deltaQty
    };

    return ga4Item;
}

export function ga4TrackBasketItems( product, initQty, newQty ) {

    const event = ( newQty > initQty ? 'add_to_cart' : 'remove_from_cart' );
    const delta = Math.abs( newQty - initQty );
    try {
        dataLayer.push( {
            'event': event,
            'ecommerce': {
                'currency': 'CZK', // Use the correct currency code here
                'value': delta * product.priceCZKWithVat,
                'items': [ product2Ga4Item( product, Math.abs( newQty - initQty ) ) ]
            }
        } );
    } catch ( e ) {
        console.log( e );
    }
}

export function ga4TrackSearch( searchTerm, searchStatus, searchSource ) {
    try {
        dataLayer.push( {
            'event': 'search',
            'search_term': searchTerm,
            'search_status': searchStatus,
            'search_source': searchSource
        } );
    } catch ( e ) {
        console.log( e );
    }
}
